import React, { useEffect, useState } from "react";
import { Box, Container, Typography, makeStyles } from "@material-ui/core";
import useScreensize from "../../hooks/useScreensize";
import { grey } from "@material-ui/core/colors";
import StVorstand from "./StVorstand";
import client from "../../utils/API";

const useStyles = makeStyles(theme => ({
  headlineVorstand: {
    color: grey[500],
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(2),
    padding: theme.spacing(0, 3)
  }
}));

const StVorstaende = () => {
  const classes = useStyles();
  const { xs, sm, md, lg, xl, current } = useScreensize();
  const [vorstaende, setVorstaende] = useState([]);

  useEffect(() => {
    fetchVorstaende();
  }, []);

  const fetchVorstaende = () => {
    client
      .items()
      .type("vorstand")
      .toObservable()
      .subscribe(response => {
        setVorstaende(response.items);
      });
  };

  return (
    <>
      <Box bgcolor="white" py={{ xs: 2, md: 4, xl: 8 }}>
        <Container maxWidth="lg">
          <Typography
            variant="h2"
            align="center"
            className={classes.headlineVorstand}
          >
            Unsere Vorstandsmitglieder
          </Typography>
          <Box
            display="flex"
            flexDirection={xs ? "column" : "row"}
            flexWrap="wrap"
          >
            {vorstaende.map((v, idx) => (
              <Box
                width={xs || sm || md ? "100%" : "50%"}
                flexShrink={0}
                py={{ xs: 2, sm: 4 }}
                px={{ xs: 0, sm: 4 }}
                key={idx}
              >
                <StVorstand item={v} />
              </Box>
            ))}
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default StVorstaende;
